<div class="dialog">
  <div mat-dialog-title class="red">Delete Portfolios@if (!showProgressBar) {
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button>
  }</div>
  <mat-dialog-content>
    @if (!showProgressBar && !isUiTest) {
      <div>
        <div>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <span class="material-icons red" style="font-size: 36px;">delete_forever</span>
              </td>
              <td>
                <div style="margin-bottom: 10px;"><strong>{{portfolios.length}} portfolios selected</strong>
              </div>
              <div>These portfolios will be deleted, and any pending results will be ignored. However,
                historical portfolio results will be retained.
              </div>
            </td>
          </tr>
        </table>
      </div>
      <irb-inventory-grid
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        [rowData]="portfolios"
        [showSideBar]="false"
        [style.height]="'120px'"
        [style.maxHeight]="'210px'"
        [style.minHeight]="'60px'"
      [style.width]="'100%'"></irb-inventory-grid>
    </div>
  }
  @if (showProgressBar && !isUiTest) {
    <div class="dialog-body flex progress-bar">
      <irb-progress-bar [progressValue]="progressBarValue"></irb-progress-bar>
    </div>
  }
</mat-dialog-content>
@if (!showProgressBar) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-tertiary">Cancel</button>
    <button (click)="deleteSelectedPortfolios()" class="btn-medium-primary red" mat-button><span class="material-icons"
    style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete
  </button>
</mat-dialog-actions>
}
</div>